import { Dom as badphraim_dom } from 'badphraim/dom/Dom';
import { EventDispatcher } from './EventDispatcher';
export class Dom extends badphraim_dom {
    /** @override */ onNewContentInElement(targetDomNode, targetDocument, targetWindow) {
        EventDispatcher.getGlobalInstance().triggerEvent('new_content_in_element', targetDomNode, targetDocument, targetWindow);
    }
}
